import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../core/utils/material.module';
import { EulaDialogComponent } from './eula-dialog.component';
import { SanitizeHtmlPipe } from '../../core/sanitizer.pipe';

@NgModule({
  imports: [
    CommonModule,
    MaterialModule
  ],
  entryComponents: [],
  providers: [SanitizeHtmlPipe],
  declarations: [
    EulaDialogComponent,
  ],
  exports: [
    EulaDialogComponent,
  ]
})
export class EulaSharedModule { }
